import React from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants';
import { Construction } from 'lucide-react';

const ROUTE_FEATURE_LABELS: Record<string, string> = {
  [ROUTES.API_DOCS]: 'API Docs',
};

const ComingSoon: React.FC = () => {
  const { pathname } = useLocation();
  const featureLabel =
    ROUTE_FEATURE_LABELS[pathname] ??
    (pathname.slice(1).replace(/-/g, ' ') || 'This feature');

  return (
    <div className="p-6 flex flex-col items-center justify-center min-h-[60vh]">
      <div className="flex flex-col items-center max-w-md text-center">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-6">
          <Construction className="w-8 h-8 text-muted-foreground" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {featureLabel}
        </h1>
        <p className="text-gray-600">Coming soon...</p>
      </div>
    </div>
  );
};

export default ComingSoon;
